import {createContext, ReactNode, useContext} from 'react';
import {Role} from '@/pages/Admin/Catalogs/Roles';

// Define the context type
interface RolesContextType {
  roles: Role[] | null;
  loading: boolean;
  error: any | null;
}

// Create the context with default values
const RolesContext = createContext<RolesContextType>({
  roles: null,
  loading: false,
  error: null,
});

// Props for the provider component
interface RolesProviderProps {
  children: ReactNode;
  roles: Role[] | null;
  loading: boolean;
  error: any | null;
}

// Provider component
export const RolesProvider = ({ children, roles, loading, error }: RolesProviderProps) => {
  return (
    <RolesContext.Provider value={{ roles, loading, error }}>
      {children}
    </RolesContext.Provider>
  );
};

// Custom hook to use the roles context
export const useRoles = () => {
  const context = useContext(RolesContext);
  if (context === undefined) {
    throw new Error('useRoles must be used within a RolesProvider');
  }
  return context;
};

export default RolesContext;
